<template>
    <div id="video" class="popin-modal full" v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_videoDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_videoClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div class="popin-content">
                    <div class="popin-content-container">
                        <iframe frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen
                            v-bind:src="videoUrl"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es';

export default {
    name: "Video",
    components: {},
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        // video parameters
        videoUrl: null
    }),
    methods: {
        popin_videoDisplayed: function(video_url) {
            this.videoUrl = video_url;

            this.isPopinDisplayed = true;
        },
        popin_videoClosed: function() {
            var self = this;
            anime({
                targets: 'div#video.popin-modal > div.popin-container',
                opacity: [1, 0],
                duration: 250,
                easing: 'linear',
                complete: function(anime) {
                    self.isPopinDisplayed = false;
                    self.videoUrl = null;
                }
            });
        },
        popin_videoDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            var self = this;
            anime({
                targets: 'div#video.popin-modal > div.popin-container',
                opacity: [0, 1],
                duration: 250,
                easing: 'linear'
            });
        }
    }
}
</script>